;(function ( $ ) {

    /**
     *  stickyFooter
     *  fixed footer on short pages
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'stickyFooter';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.checkPageHeight();
            var _this = this;
            $(window).smartresize(function() {
                _this.checkPageHeight();
            });
        },

        checkPageHeight: function() {
            var $body = $('body'),
                $main = $body.find('main'),
                $foot = $body.find('footer');


            if (($main.outerHeight() + $main.offset().top + $foot.outerHeight() + 100) < $(window).height()) {
                $foot.addClass('fixed');
            } else {
                $foot.removeClass('fixed');
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
